import React from "react";

const IconCallEnd = (props) => {
  return (
    <svg
      width={33}
      height={13}
      viewBox="0 0 33 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.57418 9.82454L3.09866 11.4032C3.85613 12.1876 5.01483 12.4318 6.02442 12.0198L8.72901 10.9161C10.0131 10.3921 10.6812 8.97131 10.2657 7.64812L10.1075 7.14463C10.1075 7.14463 12.9684 5.30867 16.7391 5.37448C20.5098 5.4403 23.3048 7.37499 23.3048 7.37499L23.1293 7.87266C22.6678 9.18054 23.2859 10.6238 24.5509 11.1923L27.2153 12.3897C28.2099 12.8366 29.3765 12.633 30.1608 11.8756L31.7395 10.3511C32.7989 9.32802 32.8284 7.63983 31.8053 6.58042C23.6208 -1.8949 10.1153 -2.13064 1.64 6.05388C0.580583 7.07695 0.551116 8.76513 1.57418 9.82454Z"
        fill="#FDFEFE"
      />
    </svg>
  );
};

export default IconCallEnd;
